import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-851fe0ae"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["width", "height", "src"];
export default /*#__PURE__*/ _defineComponent({
    props: {
        base: null,
        width: null
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("img", {
                    width: __props.width,
                    height: __props.width,
                    src: require(`../../../public/assets/icon/${props.base}.png`)
                }, null, 8, _hoisted_1)
            ]));
        };
    }
});
